import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { AnnouncementBar } from '../components/AnnouncementBar';

interface MainLayoutProps {
    children: React.ReactNode;
    showAnnouncement?: boolean;
}

export const MainLayout = ({ children, showAnnouncement = true }: MainLayoutProps) => {
    return (
        <div className="min-h-screen bg-background text-text-primary transition-colors duration-300">
            {showAnnouncement && <AnnouncementBar />}
            <Navbar />
            <main>{children}</main>
            <Footer />
        </div>
    );
};
